import { View } from "binder"
import { LastTenSalesViewModel } from "./lastTenSales-viewModel"

export class LastTenSalesView extends View<LastTenSalesViewModel>{
    GetViewUniqueId(): string {
        return "V-50854C4E-B0E8-4FF7-B26F-7DE049B0253E"
    }
    loadHtml(): string {
        let element = require('./lastTenSales.html').default;
        let style = require('./lastTenSales.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set hasGenAndMobBrand(v: boolean) { this._hasGenAndMobBrand = v; } public get hasGenAndMobBrand(): boolean { return this._hasGenAndMobBrand;} private _hasGenAndMobBrand: boolean;
    public set fileContent(v: string) { this._fileContent = v; } public get fileContent(): string { return this._fileContent; } private _fileContent: string;
    public set fileName(v: string) { this._fileName = v; } public get fileName(): string { return this._fileName; } private _fileName: string;
    public set fileChoosed(v: boolean) { this._fileChoosed = v; } public get fileChoosed(): boolean { return this._fileChoosed;} private _fileChoosed: boolean;

    chooseFile(){
        this.dataContext.chooseFile();
    }

    downloadFile(){
        this.dataContext.downloadFile();
    }
}
